import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import StatCard from '../../components/StatCard';
import StatusBadge from '../../components/StatusBadge';
import ExportButton from '../../components/ExportButton';
import { getSyncHealthReport } from '../../utils/queries';

export default function SyncHealthReport() {
	const { activeStoreId } = useContext(MyContext);
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getSyncHealthReport({ storeId: activeStoreId || undefined }).then((result) => {
			if (result?.success) setReport(result.data);
			setLoading(false);
		});
	}, [activeStoreId]);

	const columns = [
		{
			key: 'id',
			header: 'Submission ID',
		},
		{
			key: 'order_id',
			header: 'Order',
			render: (value) =>
				value ? (
					<Link to={`/orders/${value}`} className='hover:underline'>
						Order #{value}
					</Link>
				) : (
					''
				),
		},
		{
			key: 'status',
			header: 'Status',
			render: (value) => <StatusBadge status='failed' text={value} />,
		},
		{ key: 'error', header: 'Error' },
		{
			key: 'last_attempt_at',
			header: 'Last Attempt',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<div className='flex items-center justify-between mb-6'>
				<h1 className='text-2xl font-light tracking-tight'>ERP Sync Report</h1>
				<ExportButton
					fileName='sync-health-report'
					sections={[
						{
							data: report?.rows || [],
							columns: columns.map((c) => c.header),
							columnKeys: columns.map((c) => c.key),
							columnTypes: ['text', 'text', 'text', 'text', 'date'],
						},
					]}
				/>
			</div>

			{loading || !report ? (
				<div className='text-sm text-gray-400'>Loading...</div>
			) : (
				<>
					<div className='grid grid-cols-2 gap-4 mb-8'>
						<StatCard label='ERP Submissions' value={report.summary.erp_total} />
						<StatCard label='ERP Success Rate' value={report.summary.erp_success_rate != null ? `${report.summary.erp_success_rate}%` : '-'} />
					</div>

					<h2 className='text-base font-medium mb-3'>Recent Failures</h2>
					<DataTable columns={columns} data={report.rows} emptyHeading='No recent failures' />
				</>
			)}
		</div>
	);
}
